import { defHttp } from 'xmgoing-server';

const _URL = {
  subAppMenu: '/pe-portal/manage/menu/tree',  //-->获取用户菜单
};


export function getSubAppMenuApi(params: any) {
  return defHttp.get({ url: _URL.subAppMenu, params });
}
